<template>
  <header class="header-mobile">
    <div class="top-row">
      <div class="ph"></div>
      <div class="title">
        <h1 @click="goHome">Signing</h1>
        <h2>Prints voor professionals</h2>
      </div>

      <section class="search-cell" v-if="$route.name !== 'printStore'">
        <search-menu></search-menu>
      </section>

      <section class="cart-cell pointer" @click="startCheckout">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="18"
          viewBox="0 0 22 18"
          :class="['ico-cart', { added: addToBasket }]"
          src="@/images/cart.svg"
        >
          <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
            <polyline
              stroke="#002169"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              points="19.565 0 16.957 0 14.348 10.435 1.304 10.435 0 3.913"
            />
            <circle cx="3.304" cy="14.739" r="2" fill="#002169" />
            <circle cx="13.087" cy="14.739" r="2" fill="#002169" />
          </g>
        </svg>
      </section>
    </div>
    <search-bar
      class="searchbar"
      v-if="$route.name === 'printStore'"
    ></search-bar>
  </header>
</template>

<script>
import SearchMenu from '@/features/printstore/children/search/SearchMenu.vue'

import InteractionMixin from '@/mixins/InteractionMixin'
import SearchBar from '../search/SearchBar.vue'

import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  props: {
    addToBasket: {
      default: false
    }
  },
  mixins: [InteractionMixin],
  components: { SearchMenu, SearchBar },
  methods: {
    startCheckout() {
      if (this.printStoreStore.orderDetails.cart.length < 1) {
        return
      }
      this.printStoreStore.routeBeforeCheckout(this.$router.currentRoute)
      const printOrder = this.rootStore.interactions.find(
        (ia) => ia.destination === 'printOrder'
      )
      this.startInteraction(printOrder)
    },
    goHome() {
      this.$router.push({ name: 'printStore' })
    },
    titleAction() {
      if (this.$route.name === 'printStoreSearchResults') {
        return
      } else if (this.$route.params.productId) {
        this.$router.push({
          name: 'printStoreCollection',
          params: {
            categoryId: this.$route.params.categoryId,
            collectionId: this.$route.params.collectionId
          }
        })
      } else if (this.$route.params.collectionId) {
        this.$router.push({
          name: 'printStoreCategory',
          params: { categoryId: this.$route.params.categoryId }
        })
      } else {
        this.$router.push({ name: 'printStore' })
      }
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    collectionName() {
      return this.printStoreStore.currentCollectionName
    },
    categoryName() {
      if (this.$route.params.categoryId === 'shared') {
        return 'Aanbevolen'
      }
      let category = this.printStoreStore.getCategory()(
        this.$route.params.categoryId
      )
      return category ? category.name : ''
    },
    basketColor() {
      return {
        fill:
          this.printStoreStore.orderDetails.cart.length > 0
            ? 'var(--sub-color)'
            : '#bbb'
      }
    },
    title() {
      if (this.$route.name === 'printStoreSearchResults') {
        return 'Zoekresultaten'
      } else if (this.$route.params.categoryId) {
        return this.categoryName
      } else if (this.$route.params.collectionId) {
        return this.collectionName
      } else if (this.$route.params.productId) {
        return this.collectionName
      } else {
        return 'PrintStore'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cart-cell {
  flex-grow: 0;
  flex-shrink: 0;
  padding-left: 12px;
  padding-right: 18px;

  svg {
    height: auto;
    width: 21px;
  }

  .sub-color {
    fill: var(--sub-color);
  }
}

.search-cell {
  padding: 0 6px;
}

.searchbar {
  margin: 15px auto 0;
}

.title {
  flex-grow: 1;
}

.header-mobile {
  width: 100%;
  text-overflow: ellipsis;
}

h1 {
  font-weight: 500;
  color: var(--sub-color);
  font-size: 19px;
  line-height: normal;
  white-space: nowrap;
  margin: 0;
}

h2 {
  color: var(--sub-color);
}

.top-row {
  display: flex;
  align-items: center;
  width: 100%;
  height: 79px;

  .ph {
    width: 73px;
    flex-grow: 0;
    flex-shrink: 0;
  }
}

.added {
  animation: basket 0.5s;
}

@keyframes basket {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
}
</style>
